import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import './assets/scss/index.scss';
import { AuthProvider } from './config/auth-context';
import { configuration } from './config/authConfig';

// Initialize MSAL client
const pca = new PublicClientApplication(configuration);
// Render the application
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<React.StrictMode>
		<Router basename="/">
			<MsalProvider instance={pca}>
				<AuthProvider>
					<App />
				</AuthProvider>
			</MsalProvider>
		</Router>
	</React.StrictMode>
);
